var $ = require("./lib/qsa");
var pym = require("./lib/pym");
var pymChild;
var ANALYTICS = require("./lib/analytics");
require("./lib/webfonts");
var { isMobile } = require("./lib/breakpoints");

var dot = require("./lib/dot");
var templateSource = require("./partials/_content.html");
var template = dot.compile(templateSource);
var data = window.DATA;
let globalData = null;
let globalUpdates;


var categoryOrder = ["confirmed", "process", "announced", "not"];

/**
* First sorts the raw data alphabetically by name, with confirmation status as a secondary sort 
* Then groups the sorted data by category and reorders categories according to the provided order.
*/
function processData(rawData, categoryOrder) {
  // Group by category first
  var groupedData = rawData.reduce((acc, item) => {
    if (!acc[item.category]) {
      acc[item.category] = [];
    }
    acc[item.category].push(item);
    return acc;
  }, {});

  // Sort within each category group
  Object.keys(groupedData).forEach(category => {
    groupedData[category] = groupedData[category]
      .filter(item => item.keep_hidden !== "hidden")
      .sort((a, b) => 
        (Number(a?.line_of_succession) || Infinity) - (Number(b?.line_of_succession) || Infinity) ||
        (a.no_confirmation_needed ? 1 : -1) - (b.no_confirmation_needed ? 1 : -1) ||
        a.name.split(' ').pop().localeCompare(b.name.split(' ').pop())
      );
  });

   // Reorder categories
   return Object.fromEntries([
    ...categoryOrder.map(cat => [cat, groupedData[cat]]).filter(([,v]) => v),
    ...Object.entries(groupedData).filter(([k]) => !categoryOrder.includes(k))
  ]);

}

/**
 * Handles changes to the filter dropdown:
 * - 'all': Shows all appointees
 * - 'confirmation_needed': Shows positions requiring Senate confirmation
 * - 'no_confirmation_needed': Shows positions not requiring confirmation
 * - 'line_of_succession': Shows and sorts by presidential succession order
 * - 'cabinet_level': Shows Cabinet and Cabinet-level positions
 * 
 * For each filter, processes and sorts the data accordingly, then updates the table
 * display and adjusts the iframe height.
 */
function handleFilterChange(event) {
  const selectedValue = event.target.value;
  let filteredData;
  let confirmationCount = 0;

  // Get the raw data
  const rawData = globalData;
  const updates = globalUpdates; 
  switch (selectedValue) {
    // use defualt handling, found in processData()
    case 'all':
      filteredData = processData(rawData, categoryOrder);
      break;

    // Filter to show items that need confirmation 
    case 'confirmation_needed':
      const needsConfirmation = rawData
        .sort((a, b) => (Number(a?.line_of_succession) || Infinity) - (Number(b?.line_of_succession) || Infinity))
        .filter(item => item.no_confirmation_needed !== "no-confirm")
        .filter(item => item.keep_hidden !== "hidden");
      confirmationCount = rawData.filter(item => item.no_confirmation_needed === "no-confirm").length;

      filteredData = {
        items: needsConfirmation,
        confirmationCount
      };
      break;

     // Filter to show items that don't need confirmation
    case 'no_confirmation_needed':
      const requiresConfirmation = rawData
        .sort((a, b) => (Number(a?.line_of_succession) || Infinity) - (Number(b?.line_of_succession) || Infinity))
        .sort((a, b) => 
          a.name.split(' ').pop().localeCompare(b.name.split(' ').pop())
        )
        .filter(item => item.keep_hidden !== "hidden")
        .filter(item => item.no_confirmation_needed === "no-confirm");

      let noConfirmationCount = rawData.filter(item => item.no_confirmation_needed !== "no-confirm").length;
      filteredData = {
        items: requiresConfirmation,
        noConfirmationCount
      };
      break;

    // Filter and sort by succession line
    case 'line_of_succession':
      filteredData = {
        items: rawData
        .filter(item => item.keep_hidden !== "hidden")
          .filter(item => item.line_of_succession)
          .sort((a, b) => (Number(a.line_of_succession) || Infinity) - (Number(b.line_of_succession) || Infinity))
      };
      break;
      break;

    // Filter and sort by Cabinet-level positions
    case 'cabinet_level':
      const cabinetTitles = [
        "Secretary of State",
        "Treasury Secretary",
        "Defense Secretary",
        "Attorney General",
        "Interior Secretary",
        "Agriculture Secretary",
        "Commerce Secretary",
        "Labor Secretary",
        "Secretary of Health and Human Services",
        "Housing and Urban Development Secretary",
        "Transportation Secretary",
        "Energy Secretary",
        "Secretary of Education",
        "Secretary of Veterans Affairs",
        "Secretary of Homeland Security",
        "Veterans Affairs Secretary",
        "Homeland Security Secretary",
        "Vice President"
      ];

      const cabinetPositions = rawData
        .sort((a, b) => (Number(a?.line_of_succession) || Infinity) - (Number(b?.line_of_succession) || Infinity))
        .filter(item => item.keep_hidden !== "hidden")
        .filter(item => cabinetTitles.includes(item.position));

      filteredData = {
        items: cabinetPositions
      };
      break;
  }

  // Update the template with filtered data
  const tableContent = template(filteredData);
  const tableEl = document.querySelector('#table-total');
  tableEl.innerHTML = tableContent;

  // Send new height to pym
  if (window.pymChild) {
    window.pymChild.sendHeight();
  }
}

/**
 * Attempts to fetch data from NPR's JSON endpoint, falling back to window.DATA if fetch fails.
 * Processes the raw data using the processData function with categoryOrder.
 * Renders the processed data into a table using a template found in _content.html
 * Updates the iframe height via pymChild for responsive embedding.
 */
async function init() {
  try {
    var request = await fetch("https://apps.npr.org/dailygraphics/data/sheets/trump-appointees-tracker-20241114.json");
    var copy = await request.json();
    data = processData(copy.data || window.DATA, categoryOrder);
    data.updates = copy.updates || window.UPDATES;
    globalData = copy.data || window.DATA;
    globalUpdates = copy.updates || window.UPDATES;
  } catch (err) {
    console.error("Error:", err);
    data = window.DATA;
    data.updates = window.UPDATES;
  }
  var tableContent = template(data);
  var tableEl = $.one("#table-total");
  tableEl.innerHTML = tableContent;

   // Move the updates div above the dropdown
   const updatesDiv = document.querySelector('.updates');
   const dropdown = document.querySelector('.dropdown');
   if (updatesDiv && dropdown) {
     dropdown.parentNode.insertBefore(updatesDiv, dropdown);
   }

  // Set up event listener right after rendering the template
  if (dropdown) {
    dropdown.addEventListener('change', (event) => {
      const keyElement = document.querySelector('.key');
      if (keyElement) {
        keyElement.style.display =
          ['confirmation_needed', 'no_confirmation_needed'].includes(event.target.value)
            ? 'none'
            : 'flex';
      }
      handleFilterChange(event);
    });
  }

    pymChild.sendHeight();
  }

/**
* Sets up event listeners after window loads and pym.js iframe is initialized.
* 
* - Initializes the page content via init()
* - Setting up responsive iframe height management
* - Setting up the filter dropdown listener which:
*   1. Toggles visibility of the key element based on filter selection
*   2. Updates displayed data through handleFilterChange
*/
var onWindowLoaded = function () {
  pym.then(child => {
    pymChild = child;

    init();

    child.sendHeight();
    window.addEventListener("resize", () => child.sendHeight());

    //event listener for the dropdown
    document.querySelector('.dropdown')?.addEventListener('change', (event) => {
      const keyElement = document.querySelector('.key');
      if (keyElement) {
        keyElement.style.display =
          ['confirmation_needed', 'no_confirmation_needed'].includes(event.target.value)
            ? 'none'
            : 'flex';
      }
      handleFilterChange(event);
    });
  });
}

window.onload = onWindowLoaded;

// var controls = $.one(".controls");
// var categoryList = $.one("#categories-drop");
// var searchBox = $.one("#search");
// var tableContainer = $.one("#table-total");

// var filterByCategory = function(cat, list) {
//   if (!cat) {
//     return list;
//   }

//   console.log(list)

//   return list.filter(function(row) {
//     return row[cat];
//   })
// }

// var filterBySearch = function (query, list) {
//   if (!query) {
//     return list;
//   }
//   var re = new RegExp(query, "i");
//   return list.filter(
//     (r) =>
//       r.name.match(re) ||
//       r.role.match(re)
//   );
// }

// var chainFilters = function() {
//   // console.log("yeet")
//   var filters = [
//     { filter: filterByCategory, value: categoryList.value }
//     // { filter: filterBySearch, value: searchBox.value }
//   ];

//   var rows = data;
//   // console.log(data)
//   filters.forEach((def) => (rows = def.filter(def.value, rows)));
//   // rows.sort((a, b) => a.subpoena_issued - b.subpoena_issued);
//   // console.log(rows)

//   tableContainer.innerHTML = template(rows);

//   if (pymChild) {
//     pymChild.sendHeight();
//   }
// }

// // console.log(allData)
// chainFilters();

// var debounce = require("./lib/debounce");

// var debounceFilters = debounce(chainFilters);
// controls.addEventListener("input", debounceFilters);
